export default "__VITE_ASSET__4745aa33__"